import React from "react";
import { s } from "../styles";
import Items from "./Items";
import type { T4Item } from "../types";

const EN_L: ReadonlyArray<T4Item> = [
  ["14", "Employment income – Enter on line 10100."],
  ["16", "Employee's CPP contributions – includes base CPP contributions (Go to canada.ca/line-30800) and first additional CPP contributions (Go to canada.ca/line-22215)."],
  ["16A", "Employee's second CPP contributions – Employee's second additional CPP contributions (CPP2). Go to canada.ca/line-22215."],
  ["17", "Employee's QPP contributions – includes base QPP contributions (Go to canada.ca/line-30800) and first additional QPP contributions (Go to canada.ca/line-22215)."],
  ["17A", "Employee's second QPP contributions – Employee's second additional QPP contributions (QPP2). Go to canada.ca/line-22215."],
  ["18", "Employee's EI premiums – Go to canada.ca/line-31200."],
  ["20", "RPP contributions – Includes past service contributions. Go to canada.ca/line-20700."],
  ["22", "Income tax deducted – Enter on line 43700."],
  ["39", "Security options deduction 110(1)(d) – Enter on line 24900."],
  ["41", "Security options deduction 110(1)(d.1) – Enter on line 24900."],
  ["42", "Employment commissions – Enter on line 10120. This amount is already included in box 14."],
  ["43", "Canadian Armed Forces personnel and police deduction – Enter on line 24400. This amount is already included in box 14."],
  ["44", "Union dues – Enter on line 21200."],
  ["45", "Employer-offered dental benefits – Go to canada.ca/t4-information-employers."],
  ["46", "Charitable donations – Go to canada.ca/t4-information-employers."],
  ["52", "Pension adjustment – Enter on line 20600."],
  ["55", "Provincial parental insurance plan (PPIP) – Residents of Quebec, go to canada.ca/line-31205. Residents of provinces or territories other than Quebec, go to canada.ca/line-31200."],
  ["66", "Eligible retiring allowances – Go to canada.ca/line-13000."],
];

const EN_R_TOP: ReadonlyArray<T4Item> = [
  ["67", "Non-eligible retiring allowances – Go to canada.ca/line-13000."],
  ["74", "Past service contributions for 1989 or earlier years while a contributor – Go to canada.ca/line-20700."],
  ["75", "Past service contributions for 1989 or earlier years while not a contributor – Go to canada.ca/line-20700."],
  ["77", "Workers' compensation benefits repaid to the employer – Enter on line 22900."],
];

const EN_R_MID: ReadonlyArray<T4Item> = [
  ["85", "Employee-paid premiums for private health services plans – Go to canada.ca/line-33099."],
  ["87", "Emergency services volunteer exempt amount – Go to canada.ca/line-10100."],
  ["91", "Security options deduction 110(1)(d) – Enter on line 24900."],
  ["92", "Security options deduction 110(1)(d.1) – Enter on line 24900."],
];

const FR_L: ReadonlyArray<T4Item> = [
  ["14", "Revenus d'emploi – Inscrivez à la ligne 10100."],
  ["16", "Cotisations de l'employé – comprend les cotisations de base au RPC (Allez à canada.ca/ligne-30800) et les premières cotisations supplémentaires au RPC (Allez à canada.ca/ligne-22215)."],
  ["16A", "Deuxièmes cotisations de l'employé au RPC – Deuxièmes cotisations supplémentaires de l'employé au RPC (RPC2). Allez à canada.ca/ligne-22215."],
  ["17", "Cotisations de l'employé au RRQ – comprend les cotisations de base au RRQ (Allez à canada.ca/ligne-30800) et les premières cotisations supplémentaires au RRQ (Allez à canada.ca/ligne-22215)."],
  ["17A", "Deuxièmes cotisations de l'employé au RRQ – Deuxièmes cotisations supplémentaires de l'employé au RRQ (RRQ2). Allez à canada.ca/ligne-22215."],
  ["18", "Cotisations de l'employé à l'AE – Allez à canada.ca/ligne-31200."],
  ["20", "Cotisations à un RPA – Comprend les cotisations pour services passés. Allez à canada.ca/ligne-20700."],
  ["22", "Impôt sur le revenu retenu – Inscrivez à la ligne 43700."],
  ["39", "Déduction pour options d'achat de titres 110(1)d) – Inscrivez à la ligne 24900."],
  ["41", "Déduction pour options d'achat de titres 110(1)d.1) – Inscrivez à la ligne 24900."],
  ["42", "Commissions d'emploi – Inscrivez à la ligne 10120. Ce montant est déjà compris dans la case 14."],
  ["43", "Déduction pour le personnel des Forces armées canadiennes et des forces policières – Inscrivez à la ligne 24400. Ce montant est déjà compris dans la case 14."],
  ["44", "Cotisations syndicales – Inscrivez à la ligne 21200."],
  ["45", "Prestations dentaires offertes par l'employeur – Allez à canada.ca/t4-information-employeurs."],
  ["46", "Dons de bienfaisance – Allez à canada.ca/t4-information-employeurs."],
  ["52", "Facteur d'équivalence – Inscrivez à la ligne 20600."],
  ["55", "Régime provincial d'assurance parentale (RPAP) – Résidents du Québec, allez à canada.ca/ligne-31205. Résidents des autres provinces ou territoires, allez à canada.ca/ligne-31200."],
  ["66", "Allocations de retraite admissibles – Allez à canada.ca/ligne-13000."],
];

const FR_R_TOP: ReadonlyArray<T4Item> = [
  ["67", "Allocations de retraite non admissibles – Allez à canada.ca/ligne-13000."],
  ["74", "Services passés pour 1989 et les années précédentes pendant que l'employé cotisait – Allez à canada.ca/ligne-20700."],
  ["75", "Services passés pour 1989 et les années précédentes pendant que l'employé ne cotisait pas – Allez à canada.ca/ligne-20700."],
  ["77", "Indemnités pour accidents du travail remboursées à l'employeur – Inscrivez à la ligne 22900."],
];

const FR_R_MID: ReadonlyArray<T4Item> = [
  ["85", "Primes versées par l'employé à un régime privé d'assurance-maladie – Allez à canada.ca/ligne-33099."],
  ["87", "Montant exempt d'impôt versé à un volontaire des services d'urgence – Allez à canada.ca/ligne-10100."],
  ["91", "Déduction pour options d'achat de titres 110(1)(d) – Inscrivez à la ligne 24900."],
  ["92", "Déduction pour options d'achat de titres 110(1)(d.1) – Inscrivez à la ligne 24900."],
];

const DO_NOT_EN_1: ReadonlyArray<T4Item> = [
  ["30", "Board and lodging"],
  ["31", "Special work site"],
  ["32", "Travel in a prescribed zone"],
  ["33", "Medical travel assistance"],
  ["34", "Personal use of employer's automobile or motor vehicle"],
];
const DO_NOT_EN_2: ReadonlyArray<T4Item> = [
  ["36", "Interest-free and low-interest loans"],
  ["38", "Security options benefits"],
  ["40", "Other taxable allowances and benefits"],
  ["57", "Employment Income – March 15 to May 9, 2020"],
  ["58", "Employment Income – May 10 to July 4, 2020"],
];
const DO_NOT_EN_3: ReadonlyArray<T4Item> = [
  ["59", "Employment Income – July 5 to August 29, 2020"],
  ["60", "Employment Income – August 30 to September 26, 2020"],
  ["86", "Security options election"],
  ["90", "Security option benefits"],
];

const DO_NOT_FR_1: ReadonlyArray<T4Item> = [
  ["30", "Pension et logement"],
  ["31", "Chantier particulier"],
  ["32", "Voyages dans une zone visée par règlement"],
  ["33", "Aide accordée pour les voyages pour soins médicaux"],
  ["34", "Usage personnel de l'automobile ou du véhicule à moteur de l'employeur"],
];
const DO_NOT_FR_2: ReadonlyArray<T4Item> = [
  ["36", "Prêts sans intérêt ou à faible intérêt"],
  ["38", "Avantages liés aux options d'achat de titres"],
  ["40", "Autres allocations et avantages imposables"],
  ["57", "Revenus d'emploi – Du 15 mars au 9 mai 2020"],
  ["58", "Revenus d'emploi – Du 10 mai au 4 juillet 2020"],
];
const DO_NOT_FR_3: ReadonlyArray<T4Item> = [
  ["59", "Revenus d'emploi – Du 5 juillet au 29 août 2020"],
  ["60", "Revenus d'emploi – Du 30 août au 26 septembre 2020"],
  ["86", "Choix liés aux options d'achat de titres"],
  ["90", "Avantages liés aux options d'achat de titres"],
];

export default function ReversePage() {
  return (
    <div className="t4-page">
      <div style={s.rev}>
        <div style={s.revH}>Report these amounts on your tax return.</div>
        <div style={s.rtwo}>
          <div style={s.rc}>
            <Items list={EN_L} />
          </div>
          <div style={s.rc}>
            <Items list={EN_R_TOP} />
            <div style={s.rbox}>
              <div style={s.rl}>
                <b>78</b> &ndash; Fishers &ndash; Gross income
                <br />
                <b>79</b> &ndash; Fishers &ndash; Net partnership amount
                <br />
                <b>80</b> &ndash; Fishers &ndash; Shareperson amount
              </div>
              <div style={s.rr}>
                See Form T2121. <b>Do not</b> enter on line 10100.
              </div>
            </div>
            <div style={s.rbox}>
              <div style={s.rl}>
                <b>81</b> &ndash; Placement or employment agency workers
                <br />
                <b>82</b> &ndash; Taxi drivers and drivers of other passenger-carrying vehicles
                <br />
                <b>83</b> &ndash; Barbers or hairdressers
              </div>
              <div style={s.rr}>
                Gross income. See Form T2125. <b>Do not</b> enter on line 10100.
              </div>
            </div>
            <Items list={EN_R_MID} />
            <div style={s.rbox}>
              <div style={s.rl}>
                The Canada Revenue Agency uses the term <b>Indian</b> because it has legal meaning in the Indian Act.
                <br />
                <b>69</b> &ndash; Indian Act (exempt income) &ndash; Non-eligible retiring allowances
                <br />
                <b>71</b> &ndash; Indian Act (exempt income) &ndash; Employment
                <br />
                <b>88</b> &ndash; Indian Act (exempt income) &ndash; Self-employed
                <br />
                <b>94</b> &ndash; Indian Act (exempt income) &ndash; RPP contributions
                <br />
                <b>95</b> &ndash; Indian Act (exempt income) &ndash; Union dues
              </div>
              <div style={s.rr}>
                See Form T90. <b>Do not</b> enter these amounts on line 10100, line 13000 or lines 13499 to 14300.
              </div>
            </div>
          </div>
        </div>
        <div style={s.donot}>
          <b>
            Do not report these amounts on your tax return. For Canada Revenue Agency use only.
          </b>{" "}
          (Amounts in boxes 30, 32, 34, 36, 38, 40, 57, 58, 59, 60, 86 and 90 are already included in box 14.)
          <div style={s.dcols}>
            <div style={s.dc}>
              <Items list={DO_NOT_EN_1} />
            </div>
            <div style={s.dc}>
              <Items list={DO_NOT_EN_2} />
            </div>
            <div style={s.dc}>
              <Items list={DO_NOT_EN_3} />
            </div>
          </div>
        </div>
        <div style={s.rfoot}>
          <span>
            <b>T4 (25)</b>
          </span>
          <span>
            Privacy Act, personal information bank numbers CRA PPU 005 and CRA PPU 047
          </span>
        </div>

        <div className="t4-rcut" />

        <div style={s.revH}>
          Veuillez déclarer ces montants dans votre déclaration de revenus.
        </div>
        <div style={s.rtwo}>
          <div style={s.rc}>
            <Items list={FR_L} />
          </div>
          <div style={s.rc}>
            <Items list={FR_R_TOP} />
            <div style={s.rbox}>
              <div style={s.rl}>
                <b>78</b> &ndash; Pêcheurs &ndash; Revenus bruts
                <br />
                <b>79</b> &ndash; Pêcheurs &ndash; Montant net d'un associé de la société de personnes
                <br />
                <b>80</b> &ndash; Pêcheurs &ndash; Montant du pêcheur à part
              </div>
              <div style={s.rr}>
                Consultez le formulaire T2121. <b>N'inscrivez pas</b> ce montant à la ligne 10100.
              </div>
            </div>
            <div style={s.rbox}>
              <div style={s.rl}>
                <b>81</b> &ndash; Travailleurs d'agences ou de bureaux de placement
                <br />
                <b>82</b> &ndash; Chauffeurs de taxi ou d'un autre véhicule de transport de passagers
                <br />
                <b>83</b> &ndash; Barbiers et coiffeurs
              </div>
              <div style={s.rr}>
                Revenus bruts. Consultez le formulaire T2125. <b>N'inscrivez pas</b> ce montant à la ligne 10100.
              </div>
            </div>
            <Items list={FR_R_MID} />
            <div style={s.rbox}>
              <div style={s.rl}>
                L'Agence du revenu du Canada utilise le terme <b>Indien</b> en raison de sa signification légale dans la Loi sur les Indiens.
                <br />
                <b>69</b> &ndash; Loi sur les Indiens (revenu d'emploi exonéré) &ndash; Allocations de retraite non admissibles
                <br />
                <b>71</b> &ndash; Loi sur les Indiens (revenu d'emploi exonéré) &ndash; emploi
                <br />
                <b>88</b> &ndash; Loi sur les Indiens (revenu d'emploi exonéré) &ndash; travail indépendant
                <br />
                <b>94</b> &ndash; Loi sur les Indiens (revenu d'emploi exonéré) &ndash; cotisations à un RPA
                <br />
                <b>95</b> &ndash; Loi sur les Indiens (revenu d'emploi exonéré) &ndash; cotisations syndicales
              </div>
              <div style={s.rr}>
                Consultez le formulaire T90. <b>N'inscrivez pas</b> ces montants à la ligne 10100, la ligne 13000 ou aux lignes 13499 à 14300.
              </div>
            </div>
          </div>
        </div>
        <div style={s.donot}>
          <b>
            Ne déclarez pas ces montants à votre déclaration d'impôt. À l'usage de l'Agence du revenu du Canada seulement.
          </b>{" "}
          (Les montants des cases 30, 32, 34, 36, 38, 40, 57, 58, 59, 60, 86 et 90 sont déjà inclus à la case 14.)
          <div style={s.dcols}>
            <div style={s.dc}>
              <Items list={DO_NOT_FR_1} />
            </div>
            <div style={s.dc}>
              <Items list={DO_NOT_FR_2} />
            </div>
            <div style={s.dc}>
              <Items list={DO_NOT_FR_3} />
            </div>
          </div>
        </div>
        <div style={s.rfoot}>
          <span>
            <b>T4 (25)</b>
          </span>
          <span>
            Loi sur la protection des renseignements personnels, fichiers de renseignements personnels ARC PPU 005 et ARC PPU 047
          </span>
        </div>
      </div>
    </div>
  );
}